import { environment } from '../../environments/environment';
interface Scripts {
    name: string;
    src: string;
}  
export const CssStore: Scripts[] = [
    {name : 'popup',src : environment.SITE_URL+"assets/css/popup.css"}
];

/**
	this.scriptService.load('paypal').then((data:any) => {
		console.log('script loaded ', data);
	}).catch((error:any) => console.log(error));
*/
